import posthog from "posthog-js"

/**
 * Site analytics (PostHog, US cloud). The project key is a public, write-only client key;
 * leave it empty to turn analytics off.
 *
 * This PostHog project is shared with Query-U (the free plan allows one project), so every
 * portfolio event is labeled `site: "portfolio"`. Filter on that property (or $host) in PostHog
 * to see portfolio traffic only, and filter Query-U charts to $host = query-u.com.
 */
const POSTHOG_KEY = "phc_m7SWpoWn5MvPJntDVKQJsdhVwJHMaXJTyMn9nCsVi4sV"
const POSTHOG_HOST = "https://us.i.posthog.com"

// Only the real sites count. Localhost, Netlify deploy previews and any other host are ignored.
const PRODUCTION_HOSTS = ["daveneejames.com", "www.daveneejames.com", "davepowerbiportfolio.netlify.app"]
const isLocal = () => !PRODUCTION_HOSTS.includes(window.location.hostname)

export function initAnalytics() {
  if (!POSTHOG_KEY || typeof window === "undefined" || isLocal() || posthog.__loaded) return
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only", // anonymous visitors only; no person profiles are created
    capture_pageview: false, // Gatsby route changes send pageviews (see gatsby-browser.js)
    capture_pageleave: true,
  })
  posthog.register({ site: "portfolio" })
}

export function trackPageview() {
  if (posthog.__loaded) posthog.capture("$pageview")
}

/** Named events for the things a portfolio owner cares about (dashboard views, résumé downloads). */
export function track(event, properties) {
  if (posthog.__loaded) posthog.capture(event, properties)
}

/**
 * One delegated listener instead of wiring every link: records the outbound actions
 * that signal real interest (résumé downloads, email, LinkedIn, GitHub, Query-U).
 */
export function trackOutboundClicks() {
  if (typeof document === "undefined") return
  document.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest("a[href]")
    if (!a) return
    const href = a.getAttribute("href")
    const where = a.textContent.trim().slice(0, 60)
    if (/\.pdf($|\?)/i.test(href)) track("resume_downloaded", { link_text: where })
    else if (href.startsWith("mailto:")) track("email_clicked", { link_text: where })
    else if (/linkedin\.com/i.test(href)) track("linkedin_clicked", { link_text: where })
    else if (/github\.com/i.test(href)) track("github_clicked", { link_text: where })
    else if (/query-u\.com/i.test(href)) track("queryu_clicked", { link_text: where })
  })
}
